import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, getMenuDefaultIcon, isDesktop } from '../../lib/ep.js';

import ActionLink from '../builder/ActionLink';
import ButtonCollection from '../builder/ButtonCollection.js';
import BracketsButton from './buttons/BracketsButton.js';
import EnterButton from './buttons/EnterButton.js';
import EntriesButton from './buttons/EntriesButton.js';
import GalleryButton from './buttons/GalleryButton.js';
import HomeButton from './buttons/HomeButton.js';
import NetworksButton from './buttons/NetworksButton.js';
import PolicyButton from './buttons/PolicyButton.js';
import ShareButton from './buttons/ShareButton.js';
import TermsButton from './buttons/TermsButton.js';
import WinnersButton from './buttons/WinnersButton.js';
import PrizeGalleryButton from './buttons/PrizeGalleryButton.js';
import { useCommon } from '../context/commonContext.js';
import FloatingLayerPublic from './FloatingLayerPublic.js';
import LeveledHTMLText from './helpers/LeveledHTMLText.js';

const CustomMenu = ({ pm, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ display_custom_section_layer, setDisplayCustomSectionLayer ] = useState(false);

	let { share_info } = useCommon();
	if(props?.share_info) share_info = props.share_info;

	const menus = props?.menus ?? [];
	const has_ranking = pm?.has_ranking ?? false;
	const is_builder = props?.is_builder ?? false;
	const display_icons = props?.display_icons ?? true;

	const menu_layout = pm?.layout_props?.header?.menu_layout ?? 'classic';

	return (
		<ButtonCollection _class={{ other:'navigation_menu' }}>
			{menus.length > 0 && menus.map((m, i) => {
				let single_menu = m?.attributes ?? (m?.CustomMenu ?? m);

				if(single_menu.status == 0) return null;
				switch(menu_layout) {
					case 'tab':
						switch(single_menu.type) {
							case 'toc':
							case 'policy':
							case 'share':
							case 'networks':
								return null;
						}
						break;

					case 'simple':
						switch(single_menu.type) {
							case 'networks':
								return null;
						}
						break;
				}

				let Item = null;

				const item_props = {
					children:single_menu.name,
					autotranslate:false,
					is_builder,
					icon:(display_icons) ? getMenuDefaultIcon(single_menu) : false,
				};

				switch(single_menu.type) {
					case 'landing':
						Item = HomeButton;
						item_props.children = single_menu?.name ?? i18n("Home");
						break;

					case 'register':
						Item = EnterButton;

						// if undefined, the <EnterButton> item will decide
						// (for voting galleries the def. label will be "Vote", for others will be "Enter")
						item_props.children = single_menu?.name ?? null;
						break;

					case 'entries':
						Item = EntriesButton;
						item_props.children = single_menu?.name ?? (i18n((has_ranking) ? "Ranking" : "Gallery"));
						break;

					case 'galleries':
						Item = GalleryButton;
						item_props.children = single_menu?.name ?? i18n("Galleries");
						break;

					case 'winners':
						Item = WinnersButton;
						item_props.children = single_menu?.name ?? i18n("Winners");
						break;

					case 'prize_gallery':
						if(!pm?.loyalty_shop_enabled ?? false)return null;
						Item = PrizeGalleryButton;
						item_props.children = single_menu?.name ?? i18n("Rewards");
						break;

					case 'brackets':
						Item = BracketsButton;
						item_props.children = single_menu?.name ?? i18n("Brackets");
						break;

					case 'toc':
						Item = TermsButton;
						item_props.children = single_menu?.name ?? i18n("Terms and conditions");
						break;

					case 'policy':
						Item = PolicyButton;
						item_props.children = single_menu?.name ?? i18n("Privacy policy");
						break;

					case 'share':
						// MISSING PROPS (i.e. URL, etc) TO MAKE IT WORK
						Item = ShareButton;
						item_props.children = single_menu?.name ?? i18n("Share");
						item_props.cta_type = 'link';
						item_props.info = share_info;
						item_props.sharing_type='menu';
						item_props.sharing_page='header';
						item_props.promotion=pm;
						item_props.is_mobile = (!isDesktop()) ? true : false;
						break;

					case 'networks':
						Item = NetworksButton;
						item_props.children = single_menu?.name ?? i18n("Follow us");
						break;

					case 'page':
						item_props.children = single_menu?.name ?? i18n("New section");
						item_props._href = `/pages/${pm.id}/${single_menu.id}`;

						switch(single_menu.target) {
							case '3':
								// layer:
								item_props._href = null;

								let layer_text = '';
								layer_text += ((single_menu?.title ?? "").indexOf('<') == -1) ? `<h1>${single_menu.title}</h1>` : single_menu.title;
								layer_text += ((single_menu?.description ?? "").indexOf('<') == -1) ? `<p>${single_menu.description}</p>` : single_menu.description;

								item_props.onClick = () => setDisplayCustomSectionLayer(layer_text);
								break;

							case '2':
								// new window / tab:
								item_props._target = '_blank';
								break;
						}
						break;

					case 'link':
						item_props.children = single_menu?.name ?? i18n("New section");
						item_props._href = single_menu.link;
						item_props._target = ((single_menu?.target ?? '2') == '2') ? '_blank' : '_self';
						break;
				}

				if(is_builder) {
					item_props._href = null;
					item_props.onClick = null;
				}

				if(Item != null) {
					return (
						<Item
							key={`menu_item_${i}`}
							{...item_props}
							promotion={pm}
						/>
					)
				}

				return (
					<ActionLink
						key={`menu_item_${i}`}
						{...item_props}
					/>
				)}
			)}

			{(display_custom_section_layer !== false) && (
				<FloatingLayerPublic
					pm={pm}
					backButton={() => setDisplayCustomSectionLayer(false)}
				>
					<LeveledHTMLText>
						{display_custom_section_layer}
					</LeveledHTMLText>
				</FloatingLayerPublic>
			)}
		</ButtonCollection>
	);
}

export default injectIntl(CustomMenu);